// export const BASEURL = "https://www.infocorptus.com/sahjanand/api/v1/";

// export const BASEURL = "https://dev.sahjanand.infocorptus.com/api/v1/";

export const BASEURL = 'https://sahjanand.infocorptus.com/api/v1/';

// export const BASEURL = "http://192.168.23.9:3001/api/v1/";
